export const kongEndpoints = {
    dev: "/kong-api",
    // dev: "https://k.dev-apiairasia.com",
    stg: "https://k.stg-apiairasia.com",
    prod: "https://k.airasia.com",
    prd: "https://k.airasia.com",
    PRODUCTION: "https://k.airasia.com",
}